export const leadCallScheduleStrings = {
  title: "Agenda de llamadas de leads",
  subtitle:
    "Llamadas de 30 minutos que el asistente IA agendó con leads calificados. Cambia la hora, reasigna el asesor, marca la llamada como hecha o cancélala.",
  previousWeek: "Semana anterior",
  nextWeek: "Semana siguiente",
  today: "Hoy",
  ventorLabel: "Asesor",
  statusLabel: "Estado",
  allVentors: "Todos los asesores",
  allStatuses: "Todos",
  refresh: "Actualizar",
  weekSummary: (pending: number, done: number, cancelled: number) =>
    `${pending} pendiente${pending === 1 ? "" : "s"} · ${done} hecha${done === 1 ? "" : "s"} · ${cancelled} cancelada${cancelled === 1 ? "" : "s"}`,
  periods: {
    morning: "Mañana",
    afternoon: "Tarde",
    night: "Noche",
    other: "Otros horarios",
  },
  periodRange: {
    morning: "9:00 a. m. – 12:00 m.",
    afternoon: "2:00 p. m. – 5:00 p. m.",
    night: "6:00 p. m. – 9:00 p. m.",
    other: "Fuera de las franjas",
  },
  status: {
    pending: "Pendiente",
    done: "Hecha",
    cancelled: "Cancelada",
  },
  aiBadge: "IA",
  aiBadgeTooltip: "Agendada por el asistente IA de leads",
  emptyTitle: "Sin llamadas esta semana",
  emptyHint:
    "Cuando un lead elija un horario en WhatsApp, la llamada aparecerá aquí. Verifica que haya asesores con «Asignar Leads Calificados» activo.",
  emptyDay: "Sin llamadas",
  loadError: "No se pudo cargar la agenda.",
  retry: "Reintentar",
  drawerTitle: "Llamada agendada",
  customer: "Cliente",
  phone: "Teléfono",
  ventor: "Asesor asignado",
  when: "Fecha y hora",
  project: "Proyecto",
  score: "Puntaje",
  scoreValue: (score: number, max: number) => `${score}/${max}`,
  priority: {
    3: "Prioridad alta",
    2: "Prioridad media",
    1: "Prioridad baja",
  } as Record<number, string>,
  note: "Nota",
  reassignTitle: "Reasignar asesor",
  reassignHint:
    "Solo se puede asignar a un asesor con «Asignar Leads Calificados» y libre en ese horario. El cliente también pasa al nuevo asesor.",
  reassignAuto: "Automático (menor carga)",
  reassignButton: "Reasignar",
  rescheduleTitle: "Cambiar fecha y hora",
  rescheduleHint:
    "Franjas de 30 min (Bogotá): mañana 9–12, tarde 14–17, noche 18–21. Si el asesor actual no está libre, elige otro o deja «Mantener asesor» para reasignación automática.",
  rescheduleDateLabel: "Fecha",
  rescheduleTimeLabel: "Hora",
  rescheduleKeepVentor: "Mantener asesor actual",
  rescheduleButton: "Guardar horario",
  rescheduled: "Horario de la llamada actualizado.",
  markDone: "Marcar como hecha",
  cancelCall: "Cancelar llamada",
  cancelConfirmTitle: "¿Cancelar esta llamada?",
  cancelConfirmBody: "El horario quedará libre para otro lead. Esta acción no envía mensaje al cliente.",
  confirmCancel: "Sí, cancelar",
  close: "Cerrar",
  back: "Volver",
  notActionable: "Esta llamada ya no está pendiente.",
  actionError: "No se pudo completar la acción.",
  reassigned: (name: string) => `Llamada reasignada a ${name}.`,
  markedDone: "Llamada marcada como hecha.",
  cancelled: "Llamada cancelada.",
  noVentors: "No hay asesores con «Asignar Leads Calificados» activo.",
}
